<template>
  <v-card>
    <v-toolbar
      light
      color="white"
      class="elevation-2"
    >
      <v-toolbar-title>Historia</v-toolbar-title>
    </v-toolbar>
    <v-list class="users_list pb-0" v-if="historyList">
      <div class="hidden-sm-and-down">
        <v-list-tile>
          <v-layout row class="caption" :class="paddingClass">
            <v-flex xs2 class="font-weight-medium">
              Data operacji
            </v-flex>
            <v-flex xs6 class="font-weight-medium">
              Typ operacji
            </v-flex>
            <v-flex xs2 class="font-weight-medium">
              Użytkownik
            </v-flex>
            <v-flex xs2 class="font-weight-medium">
              Adres IP
            </v-flex>
          </v-layout>
        </v-list-tile>
        <v-divider></v-divider>
      </div>
      <UserItem
        v-for="(historyItem, i) in historyList"
        :key="i"
        :index="i"
        :historyItem="historyItem" />
      <div v-if="historyList && historyList.length === 0" class="px-4 py-4">
        <p class="mb-0 grey--text text--darken-1 subheading font-weight-bold">
          Brak elementów spełniających podane kryteria.
        </p>
      </div>
    </v-list>
    <div class="users_loader" v-if="!historyList">
      <div class="py-4 text-xs-center">
        <v-progress-circular
          :size="30"
          indeterminate
          color="primary"
        ></v-progress-circular>
      </div>
    </div>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex';
import UserItem from './HistoryItem.vue';

export default {
  name: 'history-list',
  props: ['history'],
  data: () => ({
    busy: false,
  }),
  components: {
    UserItem,
  },
  computed: {
    ...mapGetters('history', [
      'historyList',
    ]),
    paddingClass() {
      return this.$vuetify.breakpoint.smAndDown ? 'px-0 py-2' : 'pa-2';
    },
  },
};
</script>
